import pkg from '../../../../package.json';

export const environment = {
  production: false,
  apiUrl: 'https://api.v2.dev.activar.app/',
  version: pkg.version,
  recaptchaSiteKey: '6Lf96GEtAAAAAH3cGXQ7Yzg2gZWVlMplO4MsNBFf',
};
